// src/components/Inventory/InventoryAccordion.jsx
import React, { useCallback } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Box, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function InventoryAccordion({
  id,
  title,
  subtitle,
  children,
  defaultExpanded = true,
}) {
  const handleEntered = useCallback(() => {
    requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
  }, []);

  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      className="inv-accordion"
      TransitionProps={{ onEntered: handleEntered }}
      sx={{ mb: 2.5 }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
        className="inv-accordion-header"
        sx={{ px: 3, py: 1.5 }}
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography className="inv-accordion-title">{title}</Typography>
          {subtitle ? <Typography className="inv-accordion-subtitle">{subtitle}</Typography> : null}
        </Box>
      </AccordionSummary>

      <AccordionDetails
        id={`${id}-content`}
        className="inv-accordion-content"
        sx={{ px: { xs: 2, sm: 4 }, py: { xs: 2.5, sm: 3.5 } }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
}
